<template>
  <LinkedCompaniesSection :quote-id="quoteId" context="quote" :collapsible-component="CollapsibleSection" />
</template>

<script setup>
// Comportement réel dans le composant partagé (CC-03) : ce fichier ne fait
// plus que dire QUI on regarde (un devis, par son id) et QUELLE
// CollapsibleSection monter (celle de la v2).
import { CollapsibleSection } from '../data'
import LinkedCompaniesSection from '../shared/LinkedCompaniesSection.vue'

defineProps({
  quoteId: {
    type: [String, Number],
    required: true
  }
})
</script>
